import { Modifier } from '../modifier';
import type { Damage } from '../damage.type';
import {
  ModifierPriority,
  ModifierTags,
  StatusEffect,
  type ModifierParams,
} from '../modifier.type';
import { StatusEffectRegistry } from '../status-effects';

export class Strength extends Modifier {
  static readonly baseTitle = 'Strength';
  static readonly baseText =
    'Increase all damage dealt by the number of stacks multiplied by the number of die. Stable.';
  static readonly baseIcon = 'strength';
  static readonly baseTags = [ModifierTags.Boon];
  static readonly basePriority = ModifierPriority.Middle;

  // Instance properties that can change
  title = Strength.baseTitle;
  text = Strength.baseText;
  icon = Strength.baseIcon;
  tags: Array<ModifierTags> = [...Strength.baseTags];
  priority = Strength.basePriority;

  update(stacks: number, params: ModifierParams): void {
    super.update(stacks, params);
    this.delay = true;
  }

  startTurn() {
    if (this.delay) {
      const focus = this.owner.statusEffects.find(
        (modifier) => modifier.type === StatusEffect.Focus,
      );
      if (!focus) {
        this.delay = false;
      }
    }
  }

  endTurn() {
    if (!this.delay) {
      this.removeStacks(1);
    }
  }

  damageOut(damage: Damage) {
    damage.value += this.stacks * Math.max(damage.dice.length, 1);
  }
}

// Register the status effect
StatusEffectRegistry.register(StatusEffect.Strength, Strength);
